// extracted by mini-css-extract-plugin
export default {"container":"ChangingText_container__la8PF","slideUp":"ChangingText_slideUp__wpStJ","slideFadeUp":"ChangingText_slideFadeUp__u5-my"};